import { Injectable } from '@angular/core';
import { Dictionary } from 'projects/sepidz-web-framework/src/lib/models/dictionary';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectorService {
  dataList: Dictionary = [];
  dataStateChange: Dictionary = [];
  columns: Dictionary = [];
  takeValue: Dictionary = [];
  pathsValue: Dictionary = [];
  hasDefaultValue: Dictionary = [];
  ParetnIdValue: Dictionary = [];
  DisabledValue: Dictionary = [];
  isMultiValue: Dictionary = [];
  isFloatValue: Dictionary = [];
  submitted$: BehaviorSubject<boolean>;
  onSubmited: BehaviorSubject<boolean>;
  onDataListChanged: BehaviorSubject<boolean>;
  onParetnIdValueChanged: BehaviorSubject<boolean>;
  onFocused: boolean = false;
  constructor() {
    this.submitted$ = new BehaviorSubject<boolean>(false);
    this.onSubmited = new BehaviorSubject<boolean>(false);
    this.onDataListChanged = new BehaviorSubject<boolean>(false);
    this.onParetnIdValueChanged = new BehaviorSubject<boolean>(false);
  }
  setDataList(key: string, value: any[]) {
    this.dataList[key] = value;
    this.onDataListChanged.next(true);
  }
  getDataList(key: string) {
    return this.dataList[key];
  }
  setTakeValue(key: string, value: number) {
    this.takeValue[key] = value;
  }
  getTakeValue(key: string) {
    return this.takeValue[key];
  }
  setColumns(key: string, value: any[]) {
    this.columns[key] = value;
  }
  getColumns(key: string) {
    return this.columns[key];
  }
  setHasDefaultValue(key: string, value: any) {
    this.hasDefaultValue[key] = value;
    this.onDataListChanged.next(true);
  }
  getHasDefaultValue(key: string) {
    return this.hasDefaultValue[key];
  }
  setPathsValue(key: string, value: any) {
    this.pathsValue[key] = value;
  }
  getPathsValue(key: string) {
    return this.pathsValue[key];
  }
  setDataStateChange(key: string, value: any) {
    this.dataStateChange[key] = value;
  }
  getDataStateChange(key: string) {
    return this.dataStateChange[key];
  }
  setDisabledValue(key: string, value: any) {
    this.DisabledValue[key] = value;
  }
  getDisabledValue(key: string) {
    return this.DisabledValue[key];
  }
  setisMultiValue(key: string, value: any) {
    this.isMultiValue[key] = value;
  }
  getisMultiValue(key: string) {
    return this.isMultiValue[key];
  }
  setParetnIdValue(key: string, value: any) {
    this.ParetnIdValue[key] = value;
    this.onParetnIdValueChanged.next(true);
  }
  getParetnIdValue(key: string) {
    return this.ParetnIdValue[key];
  }
  setIsFloat(key: string, value: any) {
    this.isFloatValue[key] = value;
  }
  getIsFloat(key: string) {
    return this.isFloatValue[key];
  }
}
